require("./o-doc-list.scss");

var $ = require("jquery");
let $document = $(document);

class DocumentList {
    constructor(container) {
        this.$container = $(container);

        var $orderSelect = this.$container.find("[data-o-doc-list-order-values]");

        $orderSelect.change(function () {
            window.location.href = $orderSelect.val();
        });
    }
}

let initModels = function () {
    $("[data-o-doc-list]").each(function () {
        if (this.DocumentList) return;
        this.DocumentList = new DocumentList(this);
    });
}

let init = function () {
    initModels();
}

init();


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-doc-list/o-doc-list.chunk.js